// extracted by mini-css-extract-plugin
export default {"container":"FcktRqWAVhXXRbmU9Wxv","text":"mLdsFnEMhdMhm1xXWZC7","link":"C8dZHjvPIIqnoI3pbEBi","leftIcon":"Es2rfziKCtToFhTM3ooV"};